// extracted by mini-css-extract-plugin
module.exports = {"LargeCard":"LargeCard_LargeCard__uMgc2","illustration":"LargeCard_illustration__fuLry","tagline":"LargeCard_tagline__idAyG"};